import { DisplayValue } from '@adaptiva/core/common';
import { ETrackingMethod, MetadataSerialization, TrackingProperties } from '@adaptiva/metadata/common';
import { ITimeScaleConfiguration, TimeScaleConfiguration, TimeScaleUnit } from '@adaptiva/widgets/time-scale';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-tracking-properties',
	templateUrl: 'tracking-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrackingPropertiesComponent extends BaseAuthoringPropertiesComponent<TrackingProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<TrackingProperties> = TrackingProperties;

	public methodOptions: DisplayValue[] = [
		{ display: 'Web Scraping', value: ETrackingMethod.WEB_SCRAPE },
		{ display: 'RSS', value: ETrackingMethod.RSS },
		{ display: 'Twitter', value: ETrackingMethod.TWITTER },
		{ display: 'Facebook', value: ETrackingMethod.FACEBOOK },
		{ display: 'Email Subscription', value: ETrackingMethod.EMAIL }
	];

	public webScrapeIntervalConfig: ITimeScaleConfiguration = {
		format: TimeScaleConfiguration.SCALE_MILLISECONDS,
		scaleUnits: [
			new TimeScaleUnit('hours', 0)
		]
	};

}
